import { render, staticRenderFns } from "./nearByPlace.vue?vue&type=template&id=c2fc1eb0&scoped=true"
import script from "./nearByPlace.vue?vue&type=script&lang=js"
export * from "./nearByPlace.vue?vue&type=script&lang=js"
import style0 from "./nearByPlace.vue?vue&type=style&index=0&id=c2fc1eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc1eb0",
  null
  
)

export default component.exports